export default "__VITE_ASSET__fe15504e__"